import React, { useEffect, useState } from "react";
import st from "../../style.module.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Row, Col, Modal } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import { useFieldArray, useForm } from "react-hook-form";
import cx from "../Product/DynamicForm.module.scss";
import { CircularProgress } from "@mui/material";
import AddScorePointsForm from "./AddScorePointsForm";
import AddLabel from "./AddLabel";
import { DecisionTreePostUpdateApi, deleteDecisionTreeApi, getDecisionTreeListApi, getExtraFieldApi } from "../../services/DecisionTree";

function AddScoreForm() {
  const [getQueResData, setQueResData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPost, setIspost] = useState({
    id: "",
    flag: false,
  });
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "noOfYears",
  });

  const [extraFieldId, setExtraFieldId] = useState("");
  const [getDeleteInfo, setDeleteInfo] = useState({});
  const [userDeleteModel, setIsDeleteModel] = useState(false);
  const setUserDeleteCloseModel = () => {
    setDeleteInfo({});
    setIsDeleteModel(false);
  };

  const deleteModel = (index) => {
    setDeleteInfo({
      index: index,
    });
    setIsDeleteModel(true);
  };

  const deleteItemQue = async (index) => {
    const queId = getQueResData[index]?.id;
    if (queId) {
      setIsLoading(true);
      try {
        await deleteDecisionTreeApi(queId, isPost)
      } catch (error) {
        getProductList();
        console.error(error, "Error submitting form:");
      } finally {
        setTimeout(() => {
          getProductList();
          setUserDeleteCloseModel();
        }, 2000);
      }
    } else {
      remove(index);
      setUserDeleteCloseModel();
    }
  };

  const getExtraField = async () => {
    setIsLoading(true);

    try {
      const data = await getExtraFieldApi();

      setExtraFieldId(
        data?.data?.filter((item) => item?.extraField === "NumberOfYears")[0]
          ?._id
      );
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  };

  const getProductList = async () => {
    setIsLoading(true);
    try {
      const result = await getDecisionTreeListApi();
      if (result?.data?.data[0]?._id) {
        setIspost({
          id: `${result?.data?.data[0]?._id}`,
          flag: true,
        });
      }
      reset({ noOfYears: result?.getQueData });
      setQueResData(result?.getQueData);
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  };

  const onSubmit = async ({ noOfYears }) => {
    try {
      await DecisionTreePostUpdateApi(noOfYears, extraFieldId, isPost);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        getProductList();
      }, 2000);
    }
  };

  useEffect(() => {
    getExtraField();
    getProductList();
  }, []);

  return (
    <section className={`marginTopMobile ${st.pageWrapper} py-lg-3 py-md-2`}>
      {isLoading && (
        <CircularProgress
          className="position-fixed"
          style={{ top: "45%", right: "50%" }}
        />
      )}
      <div className={`${st.pageWrapperInside}`}>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row className="py-3">
                <Col md={12}>
                  <h4 className="fw-bold mb-3">Decision Tree</h4>
                </Col>
                <Col md={11}>
                  {fields.map((item, index) => {
                    if (!getValues(`noOfYears.${index}.children`)?.length) {
                      setValue(`noOfYears.${index}`, {
                        label: "",
                        min: "",
                        max: "",
                        children: [
                          {
                            label: "",
                            riskLabel: "",
                            stockDistribution: [
                              {
                                key: "",
                                value: "",
                              },
                            ],
                          },
                        ],
                      });
                    }
                    return (
                      <div
                        key={index}
                        className={`position-relative ${st.contentBox}`}
                      >
                        <AddLabel {...{
                          control,
                          register,
                          watch,
                          errors,
                          getValues,
                          setValue,
                          clearErrors,
                          setError,
                        }} index={index} />


                        <Row>
                          <Col lg={12}>
                            <AddScorePointsForm
                              nestIndex={index}
                              {...{
                                control,
                                register,
                                errors,
                                getValues,
                                watch,
                                setValue,
                                clearErrors,
                                setError,
                              }}
                            />
                          </Col>
                        </Row>

                        <hr />
                        <Row className="px-0 mx-0">
                          <Col lg={12}>
                            <div
                              className={`${st.box_bottom_btnDiv} ${cx.deleteButton}`}
                              onClick={() => deleteModel(index)}
                            >
                              <div className={`${st.delete_box}`}>
                                <button type="button" className={`btn`}>
                                  <MdDelete />
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                  <button
                    className={`btn text-white ${st.btnDisabled}`}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Submit
                  </button>
                </Col>
                <Col md={1}>
                  <div
                    className={`${st.sideBtna_showHide}`}
                    onClick={() =>
                      append({
                        label: "",
                        min: "",
                        max: "",
                        children: [],
                      })
                    }
                  >
                    <span>
                      <button type="button" className="btn">
                        <FiPlusCircle />
                        Add years
                      </button>
                    </span>
                  </div>
                </Col>
              </Row>
            </form>
          </Card.Body>
        </Card>
      </div>

      <Modal
        centered
        show={userDeleteModel}
        onHide={() => {
          setUserDeleteCloseModel();
        }}
        style={{ display: "block" }}
      >
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <h4
              style={{
                textAlign: "center",
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              Are you sure to delete this Question?
            </h4>
            <div
              className={`${st.modalButtonBottom} d-flex justify-content-between`}
            >
              <button
                onClick={() => {
                  setUserDeleteCloseModel();
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  deleteItemQue(getDeleteInfo?.index);
                }}
                type="button"
                className="btn btn-primary"
              >
                yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}
export default AddScoreForm;